import { render, staticRenderFns } from "./HeatmapReport.vue?vue&type=template&id=06739eca&scoped=true"
import script from "./HeatmapReport.js?vue&type=script&lang=js&external"
export * from "./HeatmapReport.js?vue&type=script&lang=js&external"
import style0 from "./HeatmapReport.vue?vue&type=style&index=0&id=06739eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06739eca",
  null
  
)

export default component.exports